import React from 'react';
import { Reveal } from '../ui/Reveal';

const Hero = () => {
  return (
    <section id="home" className="relative min-h-[90vh] flex items-center bg-charcoal-950 pt-20 overflow-hidden">
      {/* Background Image with Dark Overlay */}
      <div className="absolute inset-0 bg-hero-pattern bg-cover bg-center opacity-30"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-charcoal-950 via-charcoal-950/90 to-charcoal-950/50"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal-950 via-transparent to-transparent"></div>
      
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          
          {/* Left Column: Text Content */}
          <div className="max-w-xl">
            <Reveal>
              <h2 className="text-gold-500 text-xl md:text-2xl font-semibold mb-4 tracking-wide">
                Trusted Commercial Real Estate Appraisals.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
                Backed by 35+ Years of Expertise.
              </h1>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="text-base md:text-lg text-gray-300 mb-10 leading-relaxed">
                MAI-Designated Appraisers delivering accurate, defensible, lender-ready valuation reports for investors, lenders, attorneys, developers, and property owners.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <a href="#contact" className="btn-gold uppercase tracking-wider text-sm inline-block">
                Request Free Consultation
              </a>
            </Reveal>
          </div>

          {/* Right Column: Video Container */}
          <Reveal delay={0.4} direction="left">
            <div className="relative w-full aspect-video md:aspect-[4/3] lg:aspect-video rounded-xl overflow-hidden border border-white/10 shadow-2xl shadow-gold-500/5 group">
              {/* Decorative Corner Accents */}
              <div className="absolute top-0 left-0 w-12 h-12 border-t-2 border-l-2 border-gold-500/40 rounded-tl-xl z-20 transition-all duration-500 group-hover:w-16 group-hover:h-16 group-hover:border-gold-500"></div>
              <div className="absolute bottom-0 right-0 w-12 h-12 border-b-2 border-r-2 border-gold-500/40 rounded-br-xl z-20 transition-all duration-500 group-hover:w-16 group-hover:h-16 group-hover:border-gold-500"></div>
              
              {/* HTML5 Video Element */}
              <video 
                autoPlay 
                loop 
                muted 
                playsInline 
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              >
                <source src="https://media-manager-c.questera.ai/greta-media/d334477e75b4fabb65d5be5423d2041faad258e6d76e6691f8155cb326e304c728474a3a46f4e57b3b2d456fd1aa0681/videos/dmlkZW8vbXA0/63304f4a5fb72c1e92785021175c21fd.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              
              {/* Subtle Dark Overlay to blend with the theme */}
              <div className="absolute inset-0 bg-charcoal-950/20 group-hover:bg-transparent transition-colors duration-500 z-10 pointer-events-none"></div>
            </div>
          </Reveal>

        </div>
      </div>
    </section>
  );
};

export default Hero;